import '../styles/index.scss'

import Navbar from './navbar'

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

const application = Application.start()
const context = require.context("./controllers", true, /\.js$/)
application.load(definitionsFromContext(context))

document.addEventListener("DOMContentLoaded", (event) => {
  // anything you need to do when the site is loaded
})
